<script lang="ts">
  /** Rectangle / ellipse / diamond used to group and annotate board regions. */
  import { NodeResizer, type NodeProps } from '@xyflow/svelte';
  import type { BoardItemStyle, ShapeVariant } from '../../lib/types';
  import { getBoardActions } from '../../lib/boardContext';

  type Props = NodeProps & {
    data: {
      content: string | null;
      style: BoardItemStyle;
    };
  };

  let { id, data, selected, width, height }: Props = $props();

  const actions = getBoardActions();

  let style = $derived(data.style ?? {});
  let variant = $derived((style.shapeVariant ?? 'rectangle') as ShapeVariant);

  let borderRadius = $derived(variant === 'ellipse' ? '50%' : '0.375rem');
  let clipPath = $derived(
    variant === 'diamond' ? 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)' : 'none',
  );
</script>

<NodeResizer
  isVisible={selected}
  minWidth={40}
  minHeight={40}
  color="#2563eb"
  onResizeStart={() => actions.onResizeStart?.(id)}
  onResizeEnd={(_event, params) => actions.onResizeEnd(id, params)}
/>

<div
  class="shape-node"
  class:selected
  style="
    width: {width ? `${width}px` : '160px'};
    height: {height ? `${height}px` : '120px'};
    background: {style.fill ?? '#dbeafe'};
    border-color: {style.stroke ?? '#93c5fd'};
    color: {style.textColor ?? '#1e3a8a'};
    opacity: {style.opacity ?? '1'};
    border-radius: {borderRadius};
    clip-path: {clipPath};
  "
>
  {#if data.content}
    <span class="shape-label">{data.content}</span>
  {/if}
</div>

<style>
  .shape-node {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid;
    box-sizing: border-box;
    font-size: 0.75rem;
    font-weight: 500;
    padding: 0.5rem;
    text-align: center;
    cursor: grab;
  }

  /* Outline instead of border-color change so the shape's own stroke is preserved */
  .shape-node.selected {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }

  .shape-label {
    word-break: break-word;
  }
</style>
